const RequestTransferStatus = {
  INITIAL: 0,
  APPROVE: 1,
  CANCEL: 2
}
export default RequestTransferStatus
